<template>
  <div class="inp-container">
    <div class="inp-content">
      <div class="grid">
        <div class="inp-card">
          <div class="ins-header" :style="'background:'+row.bgColor4">
            <div class="bg-title white-color" v-html="row.title4"></div>
          </div>
          <div class="ins-view" :style="'background: url('+row.image4+')'">
            <div class="text" v-html="row.body4"></div>
            <router-link v-if="row.button4" class="ab-btn" :to="row.redirect4">{{ row.button4 }}</router-link>
          </div>
        </div>

        <div class="inp-card">
          <div class="ins-view inpro-view" :style="'background: url('+row.image5+')'"></div>
          <div class="ins-details" :style="'background:'+row.bgColor5">
            <div>
              <div class="bg-title mb-3 white-color" v-html="row.title5"></div>
               <div class="text" v-html="row.body5"></div>
               <router-link v-if="row.button5" class="ab-btn" :to="row.redirect5">{{ row.button5 }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.inp-container {
  margin-bottom: 0.7rem;
}
.grid {
  display: grid;
  grid-template-columns: repeat(2,minmax(0,1fr));
  grid-gap: 12.25rem;
  gap: 0.7rem;
  width: 100%;
}
.inp-card > div {
  height: 50%
}
.ins-header {
  padding: 90px 60px
}
.ins-view,
.ins-details {
  padding: 60px;
}
.ins-view {
  background-size: cover !important;
}
.text {
  color: #fff;
  line-height: 1.4;
  font-size: 19px;
  font-weight: normal;
  margin-bottom: 40px;
}
.bg-title {
  font-size: 53px;
}
.ab-btn {
  border: 1px solid #fff;
  padding: 9px 25px;
  line-height: 1;
  font-size: 17px;
  color: #fff;
  display: inline-block;
}
.ab-btn:hover {
  background: #fff;
  color: #000;
}
.ab-btn:active {
  opacity: 0.6;
}
.ins-details {
  display: flex;
  place-items: center;
}


/* Extra small devices (portrait phones, less than 576px) */
@media (max-width: 575.98px) {
  
}

@media (max-width: 767.98px) {
  .grid {
    grid-template-columns: repeat(1,minmax(0,1fr));
  }
  .inpro-view {
    background-position: center;
    height: 230px !important;
  }
  .inp-card > div {
    height: auto
  }
  .ins-header {
    padding: 40px;
  }
  .ins-view, .ins-details {
    padding: 40px;
  }
  .ins-view {
    background-position: bottom !important;
  }
  .bg-title {
    font-size: 45px;
  }
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767.98px) {

}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199.98px) {
  .text {
    font-size: 17px;
    margin-bottom: 17px;
  }
  .bg-title {
    font-size: 40px;
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>

<script>
export default {
  name: "Section2",
  props: ['row'],
  components: {},
  data() {
    return {
      pgLoading: true,
    };
  },
  created() {
      //
  },
  methods: {
    //
  },
};
</script>
